export default {
  NAME: 'development',
  API_URL: 'http://app.examiz.local'
}